import React, {useState, useEffect} from 'react';

import { withRouter, Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useStoreActions, useStoreState } from "easy-peasy";

function DemoSignUp(props) {
  const [email, setEmail] = useState('');
  // const [accepted_terms, setAcceptedTerms] = useState(false);
  const [is_signed_up, setIsSignedUp] = useState(false);
  const signUp = useStoreActions(actions => actions.demoSignUp);
  const is_logged_in = useStoreState(state => state.is_logged_in);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (is_logged_in) {
      props.history.push("/");
    }
  }, [is_logged_in, props.history]);

  const handleSubmit = (e) => {
    e.preventDefault();
    /*
    if (!accepted_terms) {
      alert("You must accept the Terms and Conditions in order to sign up");
      return;
    }
    */
    signUp({email: email})
    .then(response => {
      if (response.success) {
        setIsSignedUp(true)
        // props.history.push("/log_in");
      } else if (response.errors) {
        window.alert(response.errors);
      }
    });
  };

  return (
    <>
    {is_signed_up && (
    <div className="row mt-5">
    <div className="col">
    <h4>The email game will never be the same with you on board, LINKOLN style. Get ready to rock! Check for an email from Linkoln to confirm your demo account.</h4>
    </div>
    </div>
    )}
    {!is_signed_up && (
      <>
      <div className="row text-center pt-5 mt-5">
        <div className="col-12">
          <h2>Welcome!</h2>
          <h3 className="mb-3">Enter your email address to try out Linkoln Email.</h3>
        </div>
      </div>
    <Form id="signup" className="row mx-3 d-flex justify-content-center" onSubmit={handleSubmit}>
      <div className="col-12 col-md-6 mx-auto bg-white shadow rounded py-3 m-3 m-sm-0">
        <Form.Group className="col-12">
          <Form.Label>Email</Form.Label>
          <Form.Control type="input" onChange={(e) => setEmail(e.target.value)} value={email}/>
        </Form.Group>
        {/*
        <Form.Group className="col-12 mx-auto my-3">
          <div className="row">
            <div className="col text-center px-0">
              <Form.Check onChange={(e) => setAcceptedTerms(e.target.value)} value={accepted_terms}/>
            </div>
            <div className="col-11 ps-0">
              <Form.Label>I agree to the <Link to="/terms" target="_blank" rel="noreferrer">Terms of Use</Link></Form.Label>
            </div>
          </div>
        </Form.Group>
        */}
        <Form.Group className="col-12 mx-auto my-3">
        </Form.Group>

        <div className="col-12">
          <Button type="submit" variant="danger btn-lg w-100 text-uppercase mt-4">Try Linkoln Email</Button>
        </div>
      </div>
    </Form>
    <div className="row">
    <div className="col-md-6 mx-auto">
      <p className="text-center text-body mt-3">
          <small>To complete your demo signup, a confirmation link will be emailed to you.<br/>
We will never sell your information to third parties.
.<br/>
          Already signed up? <Link to="/log_in" className="text-reset"><u>Login here</u></Link></small>
      </p>
</div>
</div>
      </>
    )}
    </>
  );
}

export default withRouter(DemoSignUp);
